module.exports={
	"Form": "OrganizationViewManifest",
	"Scope": "Organization-View",
	"Descriptors":
	{
		"OrganizationDetails.IDOrganization":
		{
			"Name": "Organization ID",
			"Hash": "OrgView-ID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "OrgIdentity",
				"Group": "OrgIdentity"
			}
		},
		"OrganizationDetails.GUIDOrganization":
		{
			"Name": "GUID",
			"Hash": "OrgView-GUID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "OrgIdentity",
				"Group": "OrgIdentity"
			}
		},
		"OrganizationDetails.Name":
		{
			"Name": "Organization Name",
			"Hash": "OrgView-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "OrgIdentity",
				"Group": "OrgIdentity"
			}
		},
		"OrganizationDetails.Type":
		{
			"Name": "Type",
			"Hash": "OrgView-Type",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "OrgDetails",
				"Group": "OrgDetails"
			}
		},
		"OrganizationDetails.VendorCode":
		{
			"Name": "Vendor Code",
			"Hash": "OrgView-VendorCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "OrgDetails",
				"Group": "OrgDetails"
			}
		},
		"OrganizationDetails.ExternalOrganizationID":
		{
			"Name": "External Organization ID",
			"Hash": "OrgView-ExternalOrgID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "OrgDetails",
				"Group": "OrgDetails"
			}
		},
		"OrganizationDetails.Approved":
		{
			"Name": "Approved",
			"Hash": "OrgView-Approved",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "3",
				"Width": 3,
				"Section": "OrgDetails",
				"Group": "OrgDetails"
			}
		},
		"OrganizationDetails.DisadvantagedBusiness":
		{
			"Name": "Disadvantaged Business",
			"Hash": "OrgView-DisadvantagedBusiness",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "3",
				"Width": 4,
				"Section": "OrgDetails",
				"Group": "OrgDetails"
			}
		},
		"OrganizationDetails.Email":
		{
			"Name": "Email",
			"Hash": "OrgView-Email",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 6,
				"Section": "OrgContact",
				"Group": "OrgContact"
			}
		},
		"OrganizationDetails.Phone":
		{
			"Name": "Phone",
			"Hash": "OrgView-Phone",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 6,
				"Section": "OrgContact",
				"Group": "OrgContact"
			}
		},
		"OrganizationDetails.Address":
		{
			"Name": "Address",
			"Hash": "OrgView-Address",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 12,
				"Section": "OrgAddress",
				"Group": "OrgAddress"
			}
		},
		"OrganizationDetails.City":
		{
			"Name": "City",
			"Hash": "OrgView-City",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "OrgAddress",
				"Group": "OrgAddress"
			}
		},
		"OrganizationDetails.State":
		{
			"Name": "State",
			"Hash": "OrgView-State",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "OrgAddress",
				"Group": "OrgAddress"
			}
		},
		"OrganizationDetails.Zip":
		{
			"Name": "ZIP Code",
			"Hash": "OrgView-Zip",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "OrgAddress",
				"Group": "OrgAddress"
			}
		},
		"OrganizationDetails.CreateDate":
		{
			"Name": "Created",
			"Hash": "OrgView-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 3,
				"Section": "OrgAudit",
				"Group": "OrgAudit"
			}
		},
		"OrganizationDetails.CreatingIDUser":
		{
			"Name": "Created By (User ID)",
			"Hash": "OrgView-CreatingIDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 3,
				"Section": "OrgAudit",
				"Group": "OrgAudit"
			}
		},
		"OrganizationDetails.UpdateDate":
		{
			"Name": "Last Updated",
			"Hash": "OrgView-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 3,
				"Section": "OrgAudit",
				"Group": "OrgAudit"
			}
		},
		"OrganizationDetails.UpdatingIDUser":
		{
			"Name": "Updated By (User ID)",
			"Hash": "OrgView-UpdatingIDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 3,
				"Section": "OrgAudit",
				"Group": "OrgAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "OrgIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "OrgIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "OrgDetails",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "OrgDetails",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Contact",
			"Hash": "OrgContact",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Contact",
					"Hash": "OrgContact",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Address",
			"Hash": "OrgAddress",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Address",
					"Hash": "OrgAddress",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Audit Trail",
			"Hash": "OrgAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Audit Trail",
					"Hash": "OrgAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
